import type { StateCreator } from 'zustand';
import type { DraftReplySlice, Message, WhatsAppChatStore } from '../types';

export const createDraftReplySlice: StateCreator<
  WhatsAppChatStore,
  [],
  [],
  DraftReplySlice
> = (set, get) => ({
  drafts: {},
  replyingTo: null,

  setDraft: (chatId: string, text: string) => {
    const { drafts } = get();
    if (!text.trim()) {
      const next = { ...drafts };
      delete next[chatId];
      set({ drafts: next });
    } else {
      set({ drafts: { ...drafts, [chatId]: text } });
    }
  },

  getDraft: (chatId: string) => {
    return get().drafts[chatId] || '';
  },

  clearDraft: (chatId: string) => {
    const next = { ...get().drafts };
    delete next[chatId];
    set({ drafts: next });
  },

  setReplyingTo: (message: Message | null) => {
    set({ replyingTo: message });
  },
});
